module.exports = __webpack_public_path__ + "img/user-profil.1bc8b857.png";